// @ts-nocheck
/* eslint-disable */

export default () => {
  import("react");
  import("react/jsx-dev-runtime");
  import("react/jsx-runtime");
  import("react-dom");
  import("react-dom/client").catch();
  import("react-refresh/runtime");
  import("@remix-run/react");
  import("remix:hmr");
};
